import { type MaskitoOptions } from '@maskito/core';
import { maskWithPlaceholder } from 'utils/maskito';

export const PHONE_FORMAT = '(###) ###-####';
export const PHONE_PLACEHOLDER = '(XXX) XXX-XXXX';

export const PHONE_MASK_OPTIONS: MaskitoOptions = maskWithPlaceholder(
  ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  PHONE_PLACEHOLDER,
);
